/*
 * AMP JavaScript API: https://help.useamp.com/article/757-javascript-api
 * AMP exposes its own then-only BIS.Promise; do not assume catch/finally exist.
 */
if (!customElements.get('back-in-stock')) {
  customElements.define('back-in-stock', class extends HTMLElement {
    connectedCallback() {
      if (this.onSubmit) return;
      this.form = this.querySelector('[data-bis-form]');
      this.button = this.form.querySelector('button');
      this.status = this.querySelector('[data-bis-status]');
      this.dialog = this.querySelector('dialog');
      this.trigger = this.querySelector('[data-bis-open]');
      this.trigger.addEventListener('click', () => {
        if (this.hidden) return;
        this.dialog.showModal();
      });
      this.querySelectorAll('[data-bis-close]').forEach((button) => {
        button.addEventListener('click', () => this.dialog.close());
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target !== this.dialog) return;
        const rect = this.dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right
            || event.clientY < rect.top || event.clientY > rect.bottom) this.dialog.close();
      });
      this.dialog.addEventListener('close', () => {
        if (this.isConnected) this.trigger.focus();
      });
      this.onSubmit = this.submit.bind(this);
      this.form.addEventListener('submit', this.onSubmit);
    }

    disconnectedCallback() {
      if (this.dialog?.open) this.dialog.close();
    }

    submit(event) {
      event.preventDefault();
      if (this.pending || this.hidden || !this.form.reportValidity()) return;
      const productId = Number(this.dataset.productId);
      const variantId = Number(this.dataset.variantId);
      if (!Number.isSafeInteger(productId) || productId <= 0
          || !Number.isSafeInteger(variantId) || variantId <= 0) return;

      this.pending = true;
      this.button.disabled = true;
      this.form.setAttribute('aria-busy', 'true');
      this.status.textContent = 'Submitting…';
      const finish = (message, success = false) => {
        if (!this.isConnected) return;
        this.pending = success;
        this.button.disabled = success;
        this.form.removeAttribute('aria-busy');
        this.status.textContent = message;
      };
      try {
        window.BIS.create(this.form.elements.email.value.trim(), variantId, productId).then((response) => {
          if (response?.status === 'OK') {
            finish(response.message || 'You’re signed up. We’ll email you when it’s back in stock.', true);
            if (this.isConnected) {
              this.querySelector('[data-bis-fields]').hidden = true;
              this.querySelector('.bis-success-close').hidden = false;
            }
          } else {
            const errors = Object.values(response?.errors || {}).flat().join(' ');
            finish(errors || response?.message || 'Unable to sign up. Please try again.');
          }
        });
      } catch (error) {
        finish('Unable to sign up. Please try again.');
      }
    }
  });
}
